import Swiper from "swiper";

export class TabsSlider {
    swiper

    constructor(el) {
        this.el = el;
        this.tabItems = this.el.querySelectorAll(".js-tabs-item");
        this.createTabsSlider();
        this.goToSelectedTab();
    }

    createTabsSlider() {
        this.swiper = new Swiper(this.el, {
            slidesPerView: this.el.dataset.slidesPerView || "auto",
            clickable: true,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            allowTouchMove: true
        });
    }

    goToSelectedTab() {
        this.tabItems.forEach((tab, index) => {
            tab.addEventListener("click", () => {
                this.swiper.slideTo(index, 500);
            })
        })
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-tabs-slider")
        .forEach(slider => new TabsSlider(slider));
});
